export const UK_CITIES = [
  'Aberdeen',
  'Armagh',
  'Bangor, County Down',
  'Bangor, Gwynedd',
  'Bath',
  'Belfast',
  'Birmingham',
  'Bradford',
  'Brighton',
  'Bristol',
  'Cambridge',
  'Canterbury',
  'Cardiff',
  'Carlisle',
  'Chelmsford',
  'Chester',
  'Chichester',
  'Colchester',
  'Coventry',
  'Derby',
  'Derry',
  'Doncaster',
  'Dundee',
  'Dunfermline',
  'Durham',
  'Edinburgh',
  'Ely',
  'Exeter',
  'Glasgow',
  'Gloucester',
  'Hereford',
  'Inverness',
  'Kingston upon Hull',
  'Lancaster',
  'Leeds',
  'Leicester',
  'Lichfield',
  'Lincoln',
  'Lisburn',
  'Liverpool',
  'London',
  'Manchester',
  'Milton Keynes',
  'Newcastle upon Tyne',
  'Newport',
  'Newry',
  'Norwich',
  'Nottingham',
  'Oxford',
  'Perth',
  'Peterborough',
  'Plymouth',
  'Portsmouth',
  'Preston',
  'Ripon',
  'Salford',
  'Salisbury',
  'Sheffield',
  'Southampton',
  'Southend-on-Sea',
  'St Albans',
  'St Asaph',
  'St Davids',
  'Stirling',
  'Stoke-on-Trent',
  'Sunderland',
  'Swansea',
  'Truro',
  'Wakefield',
  'Wells',
  'Westminster',
  'Winchester',
  'Wolverhampton',
  'Worcester',
  'Wrexham',
  'York',
];
